import { NavLink } from 'react-router-dom';
import { Home, Building2, Receipt, ClipboardCheck } from 'lucide-react';

export default function BottomNavigation() {
  const navigation = [
    { name: 'Dashboard', href: '/dashboard', icon: Home },
    { name: 'Providers', href: '/service-providers', icon: Building2 },
    { name: 'Quotes', href: '/quotes', icon: Receipt },
    { name: 'Jobs', href: '/jobs', icon: ClipboardCheck },
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 md:hidden z-50 pb-safe">
      <div className="flex justify-around items-center h-16 px-2 pb-1">
        {navigation.map((item) => {
          const IconComponent = item.icon;
          return (
            <NavLink
              key={item.name}
              to={item.href}
              className={({ isActive }) =>
                `flex flex-col items-center justify-center flex-1 h-full min-w-[44px] min-h-[44px] transition-colors ${
                  isActive
                    ? 'text-indigo-600'
                    : 'text-gray-600 hover:text-gray-900'
                }`
              }
            >
              {({ isActive }) => (
                <>
                  <IconComponent
                    className={`h-5 w-5 ${isActive ? 'text-indigo-600' : 'text-gray-600'}`}
                    aria-hidden="true"
                  />
                  <span className={`text-[10px] mt-0.5 ${isActive ? 'font-semibold' : 'font-medium'}`}>
                    {item.name}
                  </span>
                </>
              )}
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
}
